import { Dialog } from '@headlessui/react'
import React from 'react'

const CommentModal = ({showCommentModal, setShowCommentModal}) => {


    return (
        <Dialog open={showCommentModal} onClose={() => setShowCommentModal(false)}
            as="div"
            style={{ zIndex: '9999999999' }}
            className="fixed inset-0 z-10 flex flex-col items-center justify-center">
            <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
            <Dialog.Title />
            <Dialog.Description />
            <div className='bg-[#2D4F71] z-10 w-[90%] h-4/5 rounded-xl text-white p-3'>
                <h2 className='mt-4 text-center text-2xl font-semibold mb-4'>578 Comments</h2>
                <div className='overflow-y-scroll h-[80%]'>
                    <div className='bg-[#81AFDD] p-2 rounded-xl mb-2.5'>
                        <div className='flex items-center'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956" width={32} height={32} alt="" />
                            <p className='font-medium mx-2'>amyrobson</p>
                            <p className='opacity-50 ml-2'>1 month ago</p>
                        </div>
                        <p className='leading-5 mt-2'>Impressive! Though it seems the drag feature could be improved.</p>
                    </div>
                    <div className='bg-[#81AFDD] p-2 rounded-xl mb-2.5'>
                        <div className='flex items-center'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956" width={32} height={32} alt="" />
                            <p className='font-medium mx-2'>amyrobson</p>
                            <p className='opacity-50 ml-2'>1 month ago</p>
                        </div>
                        <p className='leading-5 mt-2'>Impressive! Though it seems the drag feature could be improved.</p>
                    </div>
                    <div className='bg-[#81AFDD] p-2 rounded-xl mb-2.5'>
                        <div className='flex items-center'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956" width={32} height={32} alt="" />
                            <p className='font-medium mx-2'>amyrobson</p>
                            <p className='opacity-50 ml-2'>1 month ago</p>
                        </div>
                        <p className='leading-5 mt-2'>Impressive! Though it seems the drag feature could be improved.</p>
                    </div>
                    <div className='bg-[#81AFDD] p-2 rounded-xl mb-2.5'>
                        <div className='flex items-center'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956" width={32} height={32} alt="" />
                            <p className='font-medium mx-2'>amyrobson</p>
                            <p className='opacity-50 ml-2'>1 month ago</p>
                        </div>
                        <p className='leading-5 mt-2'>Impressive! Though it seems the drag feature could be improved.</p>
                    </div>
                    <div className='bg-[#81AFDD] p-2 rounded-xl mb-2.5'>
                        <div className='flex items-center'>
                            <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Oval.png?updatedAt=1689681534956" width={32} height={32} alt="" />
                            <p className='font-medium mx-2'>amyrobson</p>
                            <p className='opacity-50 ml-2'>1 month ago</p>
                        </div>
                        <p className='leading-5 mt-2'>Impressive! Though it seems the drag feature could be improved.</p>
                    </div>
                </div>
                <div className='mt-5 relative'>
                    <input 
                        type="text"
                        placeholder='Write a comment'
                        className='w-full bg-[#17395A] rounded-lg focus:outline-none answer_text border-none placeholder:text-sm placeholder:text-white/50 text-sm py-3'
                    />
                    <p className='absolute right-4 top-1/2 transform -translate-y-1/2 text-sm text-[#3791EC]'>Send</p>
                </div>
            </div>
        </Dialog>
    )
}

export default CommentModal